import styled from "styled-components";

export const ChatContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  overscroll-behavior: none;
`;

export const ChatContainer = styled.div`
  height: 100%;
  width: 100%;
  overscroll-behavior: none;
  // padding-top: 47px;
  padding-bottom:15px;
  box-sizing: border-box;

  .rsc {
    // max-height: 900px;
    max-width: 1200px;
    overflow: hidden;
    height: 100%;
    margin: 0 auto;
  }

  .rsc-container {
    height: 100%;
    width: 102%;
    overflow-x: hidden;
    /* -webkit-overflow-scrolling: touch; */
  }
  .rsc-content{
    overflow-y: auto;
  }
  .rsc-cs {
    box-shadow: none;
    justify-content: flex-end;
    padding:0;
    padding-left:9px;
    padding-right:23px;
  }

  .rsc-ts {
    padding-left:9px;
    padding-right:23px;
    align-items: end;
  }

  .rsc-ts-image-container {
    width: 67px;
    order: 0 !important;
    margin-top: -7px;
  }

  .rsc-os-options {
    margin: 0 auto;
    width: 100%;
  }

  .rsc-os-option {
    border: solid 5px #dfdfdf;
    background-color: white;
    margin-right: 10px;
    border-radius: 63px;
    vertical-align: middle;
    text-align: center;
    overflow: hidden;
    /* min-width: 209px; */
    height: auto;
    line-height: normal;

    &:hover {
      border: solid 5px #272d67;

      a {
        color: #272d67;
      }
    }

    a {
      background-color: transparent;
      color: #9b9b9b;
      font-family: var(--font-family-base);
      box-shadow: none;
      width: 100%;
      height: 100%;
      font-size: 18px;
      font-weight: 600;
      line-height: normal;
      padding: 1.025em 1.75em;
      box-sizing: border-box;
      &:hover {
        opacity: 1;
      }
    }
  }

  @media screen and (max-width: 900px) {
    .rsc-ts-image-container {
      width: 57px;
    }
  }

  @media screen and (max-width: 813px) {
    .rsc-os-option {
      border-width: 2px;
      /* padding: 0 1em; */
      min-width: unset;

      &:hover {
        border-color: #dfdfdf;
        border-width: 2px;

        a {
          color: #9b9b9b;
        }
      }

      a {
        font-size: 14px;
      }
    }
  }
`;

//For Name, etc.
export const QuestionComponent = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  align-items: center;
  

  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
  }

  &.right {
    justify-content: flex-end;
  }

  .question-component {
    height: 100%;
    overflow: auto;
    padding: 75px 5% 150px;
    width: 100%;
  }

  .question__responses {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: auto;
    width: 100%;
  }
  .question__responses:not(.textbox) {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
  }
  .question__responses.textbox {
    margin-left: 0;
    margin-right: 0.5em;
    border-radius: 38px;
    border: solid 4px var(--white-two);
    padding: 0;
    display: flex;
    align-items: center;
  }

  .question__responses.textbox.filled {
    border-color: var(--dark-slate-blue);
  }
  .question__responses.textbox input {
    width: 80%;
    height: auto;
    font-family: var(--font-family-base);
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: left;
    color: black;
    padding: 0;
  }
  .question__responses.textbox input::placeholder {
    color: var(--white-two);
  }

  .question__responses.textbox {
    margin-bottom: 11px;
    height: 37px;
  }

  @media screen and (max-width: 900px) {
    .question-component__inner {
      &.right {
        align-items: flex-start;
        margin: 0;
        flex-direction: column;
        position: absolute;
        left: 70px;
      }
    }
  }

  @media screen and (max-width: 813px) {
    .question__responses.textbox {
      border: 2.3px solid #dfdfdf;
    }
    .question__responses.textbox input {
      font-size: 14px;
    }
  }
`;

//Submit Button

export const QuestionComponentButton = styled.button`
  padding: 0;
  height: 30px;
  min-width: 30px;
  color: var(--white);
  display: inline-block;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  text-align: center;
  z-index: 100;
  -webkit-transition: color ease 0.5s;
  transition: color ease 0.5s;
  -webkit-transition: box-shadow ease-in-out 0s;
  transition: box-shadow ease-in-out 0s;
  border: 0;
  background-color: var(--pale-salmon);

  &.disabled {
    background-color: #d8d8d8;
  }
`;

export const MultComponentButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  -webkit-transition: border-color 800ms;
  transition: border-color 800ms;
  width: 199px;
  height: 64px;
  vertical-align: middle;
  text-align: center;
  margin-top: 1em;
  font-weight: 600;
  background-color: var(--pale-salmon);
  border-radius: 63px;
  font-size: 22px;

  @media screen and (max-width: 813px) {
    &.multiselect-component__image-wrapper-btn {
      font-size: 14px;
      width: 72px;
      height: 30px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/views/onboarding/OnboardingStyles.js